import { Grid } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import { ReactComponent as ViberSvg } from "../assets/viber.svg";
import IconButton from "@mui/material/IconButton";
import "./Network.css";
import { MOBILE_NUMBER, TELEGRAM_ACCOUNT } from "../constants/contacts";

const networks = [
  {
    Icon: TelegramIcon,
    onClick: () => window.open(`https://t.me/${TELEGRAM_ACCOUNT}`, "_blank"),
  },
  {
    Icon: ViberSvg,
    onClick: () =>
      window.open(`viber://chat?number=${MOBILE_NUMBER}`, "_blank"),
  },
];
export default function Network() {
  return (
    <Grid container justifyContent="center" mt={1}>
      {networks.map((network, index) => {
        const Icon = network.Icon;
        return (
          <IconButton onClick={network.onClick} key={index}>
            <Icon className="network-icon" style={{ width: 25, height: 25 }} />
          </IconButton>
        );
      })}
    </Grid>
  );
}
